import React from "react";
import { Box } from "@mui/material";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";
import SentimentNeutralIcon from "@mui/icons-material/SentimentNeutral";
import SentimentSatisfiedIcon from "@mui/icons-material/SentimentSatisfied";
import SentimentVerySatisfiedIcon from "@mui/icons-material/SentimentVerySatisfied";

const RATING_ICONS = {
  1: SentimentVeryDissatisfiedIcon,
  2: SentimentDissatisfiedIcon,
  3: SentimentNeutralIcon,
  4: SentimentSatisfiedIcon,
  5: SentimentVerySatisfiedIcon,
};

/** Black & white MUI sentiment face for student review rating (1–5). */
export default function ReviewRatingIcon({ value, sx, fontSize = "medium" }) {
  const Icon = RATING_ICONS[Number(value)];
  if (!Icon) return null;

  return (
    <Icon
      fontSize={fontSize}
      sx={{
        color: "#000",
        ...sx,
      }}
    />
  );
}

export const REVIEW_RATING_OPTIONS = [
  { value: 1, label: "Poor" },
  { value: 2, label: "Fair" },
  { value: 3, label: "Good" },
  { value: 4, label: "Very Good" },
  { value: 5, label: "Excellent" },
];

export const REVIEW_RATING_BY_VALUE = Object.fromEntries(
  REVIEW_RATING_OPTIONS.map((o) => [o.value, o])
);

export function formatReviewRatingLabel(rating) {
  if (rating == null || rating === "") return "-";
  const row = REVIEW_RATING_BY_VALUE[Number(rating)];
  return row?.label ?? String(rating);
}

/** List / table cell: B&W icon + label. */
export function ReviewRatingListCell({ value, label }) {
  const num = Number(value);
  const text =
    label != null && label !== ""
      ? String(label)
      : formatReviewRatingLabel(value);
  if (text === "-" || (!num && !text)) return "-";

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.75,
        maxWidth: "100%",
      }}
    >
      {num ? (
        <ReviewRatingIcon value={num} fontSize="small" sx={{ fontSize: 20 }} />
      ) : null}
      <Box component="span" sx={{ overflow: "hidden", textOverflow: "ellipsis" }}>
        {text}
      </Box>
    </Box>
  );
}
